import { ArrowBack, Settings } from "@mui/icons-material";
import { AppBar, IconButton, Toolbar, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import FullScreenDialog from '../full-screen-dialog/FullScreenDialog';
import UserFavoriteList, { UserFavoritesListRefType } from "../user-favorites-list/UserFavoritesList";
import { useRef } from "react";
import { useQueryNotifications } from "../../queries/UseQueryNotifications";
import { useEvaluateFeature } from "../../queries/features/UseEvaluateFeature";
import { FeatureConstants } from "../../services/features-data-service/Models";
import { useAppHeaderContext } from "../../contexts/app-header-context/UseAppHeaderContext";
import { publish } from "pubsub-js";
import { EXECUTE_ACTION_TOPIC, ExecuteActionMsg } from "../../common/models/pub-sub/PubSubTopics";
import { BaseActionEnum } from "../action-menu/ActionMenuItem";
import { AddIcon } from "../action-menu/ActionMenuIcons";

export type MobileUserFavoritesProps = {
    open: boolean;
    onClose?: () => void;
};

export default function MobileUserFavorites({
    open,
    onClose
}: MobileUserFavoritesProps) {

    const { t } = useTranslation();
    const userListRef = useRef<UserFavoritesListRefType>(null);
    const { data: headerAndActionsV2Feature } = useQueryNotifications(useEvaluateFeature)({
        feature: FeatureConstants.HeaderAndActionsV2,
    });

    const headerAndActionsV2 = (headerAndActionsV2Feature ?? false);
    const {
        appHeaderContextState, 
        //setRefreshActionState,
        //setExportActionState,
        //setFavoriteActionState
    } = useAppHeaderContext();



    function onManageFavoritesClick() {
        userListRef.current?.manageFavorites();
    }

    
    function onAddFavorite() {
        publish(EXECUTE_ACTION_TOPIC, {
            action: BaseActionEnum.Favorite
        } as ExecuteActionMsg);

    }


    return (
        <FullScreenDialog open={open} onClose={() => onClose && onClose()}>
            <AppBar sx={{ position: "relative" }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit"
                        onClick={() => onClose && onClose()} aria-label="close"
                    >
                        <ArrowBack />
                    </IconButton>

                    <Typography variant="h6"
                        sx={{
                            marginLeft: theme => theme.spacing(2),
                            flex: 1,
                        }}
                    >
                        {t("userFavorites.title")}
                    </Typography>

                    {headerAndActionsV2 && <IconButton 
                        color="inherit"
                        disabled={appHeaderContextState.favoriteActionEnabled !== true}
                        sx={{ 
                            marginLeft: "auto" 
                        }} 
                        onClick={() => onAddFavorite()}
                    >

                        {AddIcon()}
                        
                    </IconButton>}


                    <IconButton color="inherit" onClick={() => onManageFavoritesClick()}>
                        <Settings />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <UserFavoriteList
                ref={userListRef}
                enabled={open}
                onClick={() => onClose && onClose()}
            />
        </FullScreenDialog>
    );
}
